import {
  CalendarEvent,
  CalendarEventModification
} from '@gfe/features/components/visualization/calendar/models/calendar.models';

import { itemColorKeys } from '@core/models/colors.model';
import { VisualizationBuilders } from '@core/models/entities/generic-entity';
import { CustomData } from '@core/models/entities/implementations/custom-data';
import { QuantifiedExpertise } from '@core/models/entities/implementations/quantified-expertise';
import { DateTimeWindow } from '@core/models/entities/implementations/time-window';
import { GenericEntityRegistryService } from '@core/services/user-models-registry/generic-entity-registry.service';
import { CircularIterator } from '@core/utils/circular-iterator';

export interface UserJobVisitV1Model {
  uid: string;
  datetime_window?: DateTimeWindow;
  site_uid: string;
  priority?: number;
  duration: string;
  reward?: number;
  penalty?: number;
  expertise_requirements: QuantifiedExpertise[];
  custom_data: CustomData;
}

export function registerJobVisitExtensions(registry: GenericEntityRegistryService): void {
  registry.registerOverrides('UserJobVisit', { defaultSortingCol: ['name'] });

  const builders: VisualizationBuilders<UserJobVisitV1Model> = {
    buildCalendarEvents: (raw: UserJobVisitV1Model): CalendarEvent[] => {
      if (!raw.datetime_window) return [];
      const colorIter = new CircularIterator(itemColorKeys);
      return [
        {
          uid: raw.uid,
          title: `Visit: ${raw.uid}`,
          start: new Date(raw.datetime_window.start),
          end: new Date(raw.datetime_window.finish),
          mainColor: colorIter.next(),
          labels: []
        }
      ];
    },
    buildCalendarModifications: (raw: UserJobVisitV1Model): CalendarEventModification[] => {
      if (!raw.datetime_window) return [];
      return [
        {
          uid: raw.uid,
          entityType: 'job_visit',
          entityTypeVersion: 'UserJobVisit',
          withNewTimes: (start: Date, end: Date) => ({
            uid: raw.uid,
            datetime_window: {
              start: start.toISOString(),
              finish: end.toISOString()
            }
          })
        }
      ];
    }
  };
  registry.registerVisualizationBuilders('UserJobVisit', builders);
}
